import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'arrayFilter'
})
export class ArrayFilterPipe implements PipeTransform {
  transform(items: any[], field: any, value: any, comp: string): any[] {
    if (!items) {
      return [];
    }

    if (!field || !value) {
      return items;
    }

    if (typeof(value) === 'string') {
      return items.filter(singleItem =>
        singleItem[field].toLowerCase().includes(value.toLowerCase())
      );
    } else {
      let filtered = items;
      if (value instanceof Array) {
        value.forEach(v => {
          filtered = this.filter(filtered, field, v, comp);
        });
      } else {
        filtered = this.filter(filtered, field, value, comp);
      }
      //value might be an array
      

      return filtered;
    }
  }

    filter(items: any[], field, value, comp: string) {
        return items.filter(i => {
            if (comp) {
                if (comp === 'eq') {
                    return i[field] === value;
                } else if (comp === 'lt') {
                    return i[field] < value;
                } else if (comp === 'gt') {
                    return i[field] > value;
                } else {
                    return items;
                }
            } else {
                return i[field] === value;
            }
        })
    }
}
